import React, {Component} from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import {Toolbar, Data} from 'react-data-grid-addons';
import {UI_HEIGHT} from '../Common/constants';
import {Grid, Row, Col, Panel, Button, ButtonGroup, Table, ButtonToolbar, Breadcrumb} from 'react-bootstrap';
import {Link} from 'react-router';
import {Line, Doughnut} from 'react-chartjs';
import Time from '../Common/time';
import Selection from '../Common/selection';
import Spinner from '../Widgets/spinner';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import InputField from '../Common/inputField';
import { Field, FieldArray } from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';

class SalesDashboard extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

            createReturnOpen: false,
            createQuoteOpen: false,
            createFavoriteOpen: false,
            availableBins: 0,
            totalBins: 0,
            totalInvoice: 0,
            totalReturn:0,
            totalOpen: 0,
            totalDelay: 0,

            orderSchedules: {
                rows: [],
                allRows: [],
                setDate: null,
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            creditLines: {
              rows: [],
              allRows: [],
              setDate: null,
              selectedRows: null,
              sortColumn: null,
              sortDirection: null,
            },

            POs: {
                rows: [],
                allRows: [],
                setDate: null,
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            SOs: {
                rows: [],
                allRows: [],
                setDate: null,
                sortColumn: null,
                sortDirection: null,
            },

            zones: {
                rows: [],
                allRows: [],
                sortColumn: null,
                sortDirection: null,
            },

            inventories: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            favorites: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);

        this.openReturnCreate = this.openReturnCreate.bind(this);
        this.closeReturnCreate = this.closeReturnCreate.bind(this);
        this.openQuoteCreate = this.openQuoteCreate.bind(this);
        this.closeQuoteCreate = this.closeQuoteCreate.bind(this);
        this.openFavoriteCreate = this.openFavoriteCreate.bind(this);
        this.closeFavoriteCreate = this.closeFavoriteCreate.bind(this);
        this.addFavorite = this.addFavorite.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchSalesDashboardDetail();
        this.props.fetchWarehouseSalesOrders(1);
        this.props.fetchWarehousePurchaseOrders(1);
        this.props.fetchWarehouseBins(1);

        this.props.fetchCustomerCreditByDate('');
        this.props.fetchCustomerOrderSchedules();
        this.props.fetchSalesOrders();
              // this.setState({totalReturn: nextProps.salesInvoices.length})
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.customerCreditLines && nextProps.customerCreditLines != this.props.customerCreditLines) {
            var newCreditLines = {...this.state.creditLines, rows: nextProps.customerCreditLines};
            this.setState({creditLines: newCreditLines});
        }

        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            var inventories = {...this.state.inventories, rows: nextProps.inventories};
            this.setState({inventories});
        }

        if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
            var favorites = {...this.state.favorites, rows: nextProps.favorites};
            this.setState({favorites});
        }

        if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail != this.props.warehouseBinsDetail) {
            let totalAvailable = 0;
            let totalWarehouseBins = 0;
            nextProps.warehouseBinsDetail.Warehouse_Zone.map(zone => {
                totalAvailable += zone.AvailableBin;
                totalWarehouseBins += zone.TotalBin;
            });

            let zones = {...this.state.zones, rows: nextProps.warehouseBinsDetail.Warehouse_Zone}
            this.setState({zones, availableBins: totalAvailable, totalBins: totalWarehouseBins});
        }

        if (nextProps.customerOrderSchedules && nextProps.customerOrderSchedules != this.props.customerOrderSchedules) {
            let orderSchedules = {...this.state.orderSchedules, rows: nextProps.customerOrderSchedules};
            this.setState({orderSchedules});
        }

        if (nextProps.orderScheduleDate && nextProps.orderScheduleDate != this.props.orderScheduleDate) {
            console.log(nextProps.orderScheduleDate);
            this.props.fetchCustomerOrderSchedulesByDate(this.formatDate(nextProps.orderScheduleDate));
            this.props.fetchCustomerCreditByDate(this.formatDate(nextProps.orderScheduleDate));
        }

        if (nextProps.dashboardSalesDetail && nextProps.dashboardSalesDetail != this.props.dashboardSalesDetail) {
            let totalInvoice = 0;
            let totalReturn = 0;
            let totalOpen = 0;
            let totalDelay = 0;
            totalInvoice = nextProps.dashboardSalesDetail.TotalReleased;
            totalReturn = nextProps.dashboardSalesDetail.TotalReturn;
            totalOpen = nextProps.dashboardSalesDetail.TotalOpen;
            totalDelay = nextProps.dashboardSalesDetail.TotalDelay;

            this.setState({totalInvoice: totalInvoice, totalDelay:totalDelay, totalReturn:totalReturn,totalOpen:totalOpen  });
        }

        }

    formatDate(date) {
      var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (date) {
        var month = String(date).slice(4,7);
        var day = String(date).slice(8,10);
        var year = String(date).slice(11, 15);

        let chosenDateFormatted = '';
        if ( parseInt(monthShortNames.indexOf(month) + 1) < 10) {
          chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month)+1) + day;
        } else {
          chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month)+1) + day;
        }
        chosenDateFormatted = chosenDateFormatted + year;
        console.log(chosenDateFormatted);
        return chosenDateFormatted;
      }
      return null;
    }

    openQuoteCreate() {
        this.setState({createQuoteOpen: true});
    }

    openFavoriteCreate() {
        this.setState({createFavoriteOpen: true});
    }

    closeQuoteCreate() {
        this.setState({createQuoteOpen: false});
    }

    closeFavoriteCreate() {
        this.setState({createFavoriteOpen: false});
    }

    openReturnCreate() {
        this.setState({createReturnOpen: true});
    }

    closeReturnCreate() {
        this.setState({createReturnOpen: false});
    }

    addFavorite(newFavorite) {
        let newRow = {
          Product_id: newFavorite.id,
          ProductNum: newFavorite.ProductNum,
          RefNum: newFavorite.ProductNum,
          PreSale: newFavorite.PreSale,
          InStock: newFavorite.InStock,
          Ordered: newFavorite.Purchased,
          Price: newFavorite.RefPurchasingPrice,
          ProductName: newFavorite.ProductNum.Name
        }
        if (newFavorite.Product) {
          newRow.ProductName = newFavorite.Product["Name"];
        }

        let preRows = this.state.favorites.rows;
        preRows.push(newRow);
        var favorites = {...this.state.favorites, rows: preRows}
        this.setState({favorites});
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseOrder(e) {
        e.preventDefault();
        const currentPurchaseOrder = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseOrder();
        this.props.selectPurchaseOrder(currentPurchaseOrder);
        this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseOrder();
        this.context.router.push('/purchaseOrder/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.

    renderCustomerOrderSchedule() {
        if (this.props.customerOrderSchedulesIsLoading && !this.props.customerOrderSchedulesError) return <Spinner/>
        else if (this.props.customerOrderSchedulesError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.customerOrderSchedulesError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.orderSchedules);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var POs = {...this.state.POs, sortColumn, sortDirection};
                this.setState({POs});
            }

            // Handle the row select function

            const onRowSelect = rows => {
                var POs = {...this.state.POs, selectedRows: rows};
                this.setState({POs});
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'CustomerID',
                    name: <Translate value="cust_id" />,
                    resizable: true,
                    sortable: true,
                    width: 70
                },
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                },
                {
                    key: 'Contact',
                    name: <Translate value="contact" />,
                    resizable: true,
                    sortable: true,
                    width: 80,
                },
                {
                    key: 'Phone',
                    name: <Translate value="phone" />,
                    resizable: true,
                    sortable: true,
                    formatter: DateFormatter, //fixed
                    width: 80,
                },
                {
                    key: 'OrderStatus',
                    name: <Translate value="order_status" />,
                    resizable: true,
                    sortable: true,
                },
            ]

            return (
              //React Table Customer Order Schedule
                <Row>
                  <Col sm={ 12 }>
                    <div id="SalesDashboard-dataGrid1">
                        <ReactDataGrid
                            rowKey='DispatchStop_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={this.state.tableHeight}
                            rowHeight={25}
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderCustomerReport() {
      if (this.props.customerCreditLinesIsLoading && !this.props.customerCreditLinesError) return <Spinner/>
      else if (this.props.customerCreditLinesError) return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.customerCreditLinesError)}</div>
      </ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.creditLines);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var creditLines = {...this.state.creditLines, sortColumn, sortDirection};
              this.setState({creditLines});
          }

          // Handle the row select function

          const onRowSelect = rows => {
              var creditLines = {...this.state.creditLines, selectedRows: rows};
              this.setState({creditLines});
          }

          //Custom Formatter component

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNameFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.Name}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNumFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'Customer_id',
                  name: <Translate value="cust_id" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 70,
              },
              {
                  key: 'CurrentAmount',
                  name: <Translate value="total_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
              },
              {
                  key: 'PassedDue',
                  name: <Translate value="passed_due" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
              },
              {
                  key: 'CreditLimit',
                  name: <Translate value="credit_limit" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
              },
          ]

          return (
            //React Table Customer Credit Report
              <Row>
                <Col sm={ 12 }>
                  <div id="SalesDashboard-dataGrid2">
                      <ReactDataGrid
                          rowKey='Customer_id'
                          onGridSort={handleGridSort}
                          columns={columns}
                          rowGetter={rowGetter}
                          rowsCount={getSize() }
                          minHeight={this.state.tableHeight}
                          rowHeight={25}
                          onRowSelect={onRowSelect}/>
                  </div>
              </Col>
            </Row>
          )
      }
    }

    renderZonesTable() {
      if (this.props.SOIsLoading && !this.props.SOError) return <Spinner/>
      else if (this.props.SOError) return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.SOError)}</div>
      </ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.zones);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var zones = {...this.state.zones, sortColumn, sortDirection};
              this.setState({zones});
          }

          // Handle the row select function

          const onRowSelect = rows => {
              var zones = {...this.state.zones, selectedRows: rows};
              this.setState({zones});
          }

          //Custom Formatter component

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNameFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.Name}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          const VendorNumFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'WarehouseZone_id',
                  name: 'Zone ID',
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'AvailableBin',
                  name: 'Bins Available',
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              },
              {
                  key: 'TotalBin',
                  name: 'Total Bins',
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true,
              }
          ]

          return (
            //React Table
              <Row>
                <Col sm={ 12 }>
                  <div id="SalesDashboard-dataGrid3">
                      <ReactDataGrid
                          rowKey='WarehouseZone_id'
                          onGridSort={handleGridSort}
                          columns={columns}
                          rowGetter={rowGetter}
                          rowsCount={getSize() }
                          minHeight={this.state.tableHeight}
                          rowHeight={25}
                          onRowSelect={onRowSelect}/>
                  </div>
              </Col>
            </Row>
          )
      }
    }

    renderInventoryTable() {
        if (this.props.favoritesAreLoading && !this.props.favoritesError) return <Spinner/>
        else if (this.props.favoritesError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.favoritesError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid
            const getRows = () => {
                return Data.Selectors.getRows(this.state.favorites);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var favorites = {...this.state.favorites, sortColumn, sortDirection};
                this.setState({favorites});
            }

            // Handle the row select function

            const onRowSelect = rows => {
                var favorites = {...this.state.favorites, selectedRows: rows};
                this.setState({favorites});
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="product" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'PreSale',
                    name: <Translate value="presale" />,
                    resizable: true,
                    sortable: true,
                    width: 80,
                    filterable: true
                },
                {
                    key: 'InStock',
                    name: <Translate value="stock" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'Ordered',
                    name: <Translate value="ordered" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'Price',
                    name: <Translate value="price" />,
                    resizable: true,
                    sortable: true,
                    width: 75
                }
            ]

            return (
              //React Table
                <Row>
                  <Col sm={ 12 }>
                    <div id="SalesDashboard-dataGrid4">
                        <ReactDataGrid
                            rowKey='Product_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={this.state.tableHeight}
                            rowHeight={25}
                            enableRowSelect='multi'
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderOrderScheduleDatePicker(handleSubmit) {
      return (
        <form onSubmit={handleSubmit}>
          <Field name="OrderScheduleDate" component={ DatePicker } />
        </form>
      )
    }

    renderNumSalesOrdersOpen() {
      if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return <Spinner/>
      else if (this.props.dashboardSalesDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.dashboardSalesDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalOpen}</div>
        )
      }
    }

    renderNumInvoicesNotFinalized() {
      if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return <Spinner/>
      else if (this.props.dashboardSalesDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.dashboardSalesDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalInvoice}</div>
        )
      }
    }

    renderNumReturns() {
      if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return <Spinner/>
      else if (this.props.dashboardSalesDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.dashboardSalesDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalReturn}</div>
        )
      }
    }

    renderTotalDelay() {
      if (this.props.dashboardSalesDetailIsLoading && !this.props.dashboardSalesDetailError) return <Spinner/>
      else if (this.props.dashboardSalesDetailError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.dashboardSalesDetailError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.state.totalDelay}</div>
        )
      }
    }

    getWarehouseOptions() {
       var warehouseOptions = [];
       this.props.warehouses.map(warehouse => {
          warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name });
       })
       return warehouseOptions;
    }

    render() {
        const { handleSubmit, numPurchaseQuotes } = this.props;
        let height = (this.state.tableHeight+ 85).toString();
        let tableCollapseFix = {height: height};
        var warehouseOptions = this.getWarehouseOptions();

        var data = [
            {color: "#97ddf0", label: "test1", value: 2},
            {color: "#fafafa", label: "test2", value: 1}
        ];

        var options = {
            animateRotate: true
        }

        let createDialogStyle = {
            width: '600px',
            marginLeft: '-10%',
        };

        var custOrderHeader = ( <Row>
          <Col xs={8}><h4><Translate value="sales_orders_scheduled" /></h4></Col>
          <Col xs={4}>{this.renderOrderScheduleDatePicker(handleSubmit)}</Col>
        </Row>
        );

        const SalesOrderRateHeader = (<h4><Translate value="sales_order_rate" /></h4>);
        const panelHeader = (<h4><Translate value="total_orders_today" /></h4>);
        const custCreditReport = ( <h4 className="pb"><Translate value="customer_credit_report" /></h4> );

        return (
          //---------------
          // Begin HTML
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item active="true">
                  <Translate value="sales_dashboard" />
                </Breadcrumb.Item>
              </Breadcrumb>

              <Grid id="sales-dashboard" fluid="true">
                <h1><Translate value="sales_dashboard" /></h1>
                {/* Dashboard Panels */}
                <Row>
                  <Time />
                  <div className="col-sm-5ths">
                    <Link to="/salesOrders">
                      <div className="panel widget">
                        <Row className="row-table">
                          <Col sm={ 5 } className="bg-blue">
                            {this.renderNumSalesOrdersOpen()}
                          </Col>
                          <Col sm={ 7 }>
                            <h3><Translate value="open_sales_orders" /></h3>
                          </Col>
                        </Row>
                      </div>
                    </Link>
                  </div>

                  <div className="col-sm-5ths">
                    <Link to="/salesInvoice">
                      <div className="panel widget">
                        <Row className="row-table">
                          <Col sm={ 5 } className="bg-red">
                            {this.renderNumInvoicesNotFinalized()}
                          </Col>
                          <Col sm={ 7 }>
                            <h3><Translate value="none_finalized_invoices" /></h3>
                          </Col>
                        </Row>
                      </div>
                    </Link>
                  </div>

                  <div className="col-sm-5ths">
                    <div className="panel widget">
                      <Row className="row-table">
                        <Col sm={ 5 } className="bg-yellow">
                          {this.renderTotalDelay()}
                        </Col>
                        <Col sm={ 7 }>
                          <h3><Translate value="delayed_sales_orders" /></h3>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div className="col-sm-5ths">
                    <Link to="/inventoryReturn">
                      <div className="panel widget">
                        <Row className="row-table">
                          <Col sm={ 5 } className="bg-green">
                            {this.renderNumReturns()}
                          </Col>
                          <Col sm={ 7 }>
                            <h3><Translate value="returned_sales_orders" /></h3>
                          </Col>
                        </Row>
                      </div>
                    </Link>
                  </div>
                </Row> {/* End Dashboard Panels */}

                {/* Quick Actions */}
                <ButtonToolbar>
                  <Button
                    bsStyle="success"
                    type="button"
                    href="/salesOrders/new">
                    <em className="fa fa-money"/><Translate value="create_new_sale_order" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    type="button"
                    href="/customerReturn">
                    <em className="fa fa-backward" /><Translate value="process_sales_return" />
                  </Button>
                  <Button
                    bsStyle="primary"
                    type="button"
                    onClick={(event) => { this.props.fetchSalesCSV(event) } }>
                    <em className="fa fa-edit"/><Translate value="generate_sales_csv_file" />
                  </Button>
                </ButtonToolbar> {/* End Quick Actions */}

                {/* Customer Order Schedule */}
                <Row>
                  <Col sm={ 6 }>
                    <Panel header={custOrderHeader} style={ tableCollapseFix }>
                      {this.renderCustomerOrderSchedule() }
                    </Panel>
                  </Col>
                  <Col sm={ 6 }>
                    <Panel header={custCreditReport} style={ tableCollapseFix }>
                      {this.renderCustomerReport() }
                    </Panel>
                  </Col>
                  {/* <Col sm={ 5 }>
                    <Panel header={SalesOrderRateHeader}>
                      <span>Customers /w orders / Total Customers</span>
                    </Panel>
                  </Col>
                <Row>
                  <Col sm={ 12 }>
                    <Panel header={panelHeader} >

                    </Panel>
                  </Col> */}
                </Row> {/* Customer Order Schedule */}
              </Grid>

                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createQuoteOpen} onCloseClicked={() => {
                    this.closeQuoteCreate()
                } } title="Create a Purchase Quote">
                    <PurchaseQuoteModal closeC={this.closeQuoteCreate}/>
                </SkyLightStateless>
                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createFavoriteOpen} onCloseClicked={() => {
                    this.closeFavoriteCreate()
                } } title="Create a new Favorite">
                    <NewFavoriteModal closeC={this.closeFavoriteCreate} closeA={this.addFavorite}/>
                </SkyLightStateless>
            </ContentWrapper>
        );
    }
}


export default SalesDashboard;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesDashboard.jsx